export type AuthStep = 'login-menu' | 'sign-up' | 'login' | 'forgot-password' | 'reset-password'
export interface PendingThirdPartyAuth {
  accessToken: string
  type: 'facebook' | 'google'
  redirectUrl?: string
  fallbackUrl?: string
}

export const isAuthStep = (step: string): step is AuthStep => {
  return ['login-menu', 'sign-up', 'login', 'forgot-password', 'reset-password'].includes(step)
}
